import { render, staticRenderFns } from "./top.vue?vue&type=template&id=5071934b"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports